import React, { Component } from "react";
import styled from 'styled-components';
import {Button, Form, Input, Select, Table, Image, message} from "antd";
import utils from '@/utils/auth';
import ServiceAPI from '@/api/service';
import StoreAPI from '@/api/store';
import copy from 'copy-to-clipboard';
const GoodsWrapper = styled.div`
  .search-wrapper {
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: flex;
      align-items: center;
      .search-input {
        width: 260px;
      }
    }
  }
`;
const GoodsInfo = styled.div`
  display: flex;
  .title {
    margin-left: 10px;
  }
`;

export default class ServiceGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        keyword: '',
        thirdId: "",
        itemStatus: '',
        kdtId: '',
        pageNum: 1,
        pageSize: 10
      },
      serviceList: [],
      total: 0,
      serviceStatusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已上架',
          value: 1
        },
        {
          label: '已下架',
          value: 2
        }
      ],
      storeList: [],
    };
  }

  componentDidMount() {
    this.initPage();
    this.initStoreList();
  }

  initPage = () => {
    const { searchParams } = this.state;
    ServiceAPI.queryServiceList(searchParams)
        .then(({ items: serviceList, paginator }) => {
          const { totalCount: total } = paginator;
          this.setState({ serviceList, total });
        });
  }

  onSearch = () => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: 1 }) }, this.initPage);
  }

  onPageChange = (current, pageSize) => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize }) }, this.initPage);
  }

  initStoreList = () => {
    StoreAPI.queryYzStoreList()
        .then(storeList => {
          this.setState({ storeList: [{ kdtName: '全部', kdtId: '' }, ...storeList] });
        });
  }

  copyText = text => {
    copy(text);
    message.success('复制成功');
  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);

    const {
      searchParams,
      serviceList,
      total,
      serviceStatusOptions,
      storeList,
    } = this.state;
    const columns = [
      {
        title: '服务',
        render: item => {
          return (
            <GoodsInfo>
              <Image width={54} src={item.imgUrl} />
              <div className="title">{item.title}</div>
            </GoodsInfo>
          );
        }
      },
      {
        title: '售价(元)',
        render: ({ price }) => (price / 100).toFixed(2)
      },
      {
        title: '服务状态',
        render: ({ itemStatus, kdtId }) => {
          const { label } = serviceStatusOptions.find(o => o.value === itemStatus) || {};
          const { kdtId: userKdtId } = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
          if (utils.isUserHeadQuarter() && kdtId === userKdtId) { // 总部 并且是当前选择总部的kdtId才展示 - 否则展示label
            return '-';
          } else {
            return label;
          }
        }
      },
      {
        title: '服务标签',
        dataIndex: 'itemTags',
        key: 'itemTags'
      },
      {
        title: '有赞服务ID',
        dataIndex: 'itemId',
        key: 'itemId'
      },
      {
        title: '三方转换ID',
        dataIndex: 'mappingItemId',
        key: 'mappingItemId'
      },
      {
        title: '操作',
        render: ({ mappingItemId = '' }) => <Button type="link" disabled={!status} onClick={() => this.copyText(mappingItemId)}>复制ID</Button>
      }
    ];

    return (
      <GoodsWrapper>
        <div className="search-wrapper">
          <Form layout="inline">
          <Form.Item label="三方转换ID">
              <Input
                allowClear
                className="search-input"
                value={searchParams.thirdId}
                placeholder="请输入三方转换ID"
                onChange={e => {
                  const value = e.target.value.trim();
                  this.setState({ searchParams: Object.assign(searchParams, { thirdId: value }) });
                }}
              />
            </Form.Item>
            <Form.Item label="服务名称">
              <Input
                allowClear
                className="search-input"
                value={searchParams.keyword}
                placeholder="请输入服务名称"
                onChange={e => {
                  const value = e.target.value.trim();
                  this.setState({ searchParams: Object.assign(searchParams, { keyword: value }) });
                }}
              />
            </Form.Item>
            <Form.Item label="服务状态">
              <Select
                  style={{ width: 200 }}
                  value={searchParams.itemStatus}
                  options={serviceStatusOptions}
                  onChange={value => {
                    this.setState({ searchParams: Object.assign(searchParams, { itemStatus: value }) });
                  }}
              />
            </Form.Item>
            {
              utils.isUserHeadQuarter() && <Form.Item label="适用门店">
                <Select
                    allowClear
                    showSearch
                    style={{ width: 200 }}
                    value={searchParams.kdtId}
                    options={storeList}
                    optionFilterProp="kdtName"
                    placeholder="请选择门店"
                    fieldNames={{
                      label: 'kdtName',
                      value: 'kdtId'
                    }}
                    onChange={value => {
                      this.setState({ searchParams: Object.assign(searchParams, { kdtId: value || '' }) });
                    }}
                />
              </Form.Item>
            }
            <Form.Item>
              <Button type="primary" onClick={this.onSearch}>查询</Button>
            </Form.Item>
          </Form>
        </div>

        <div className="content">
          <Table
            rowKey="itemId"
            columns={columns}
            dataSource={serviceList}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              total,
              showTotal: total => `共${total}条`,
              hideOnSinglePage: false,
              onChange: this.onPageChange
            }}
          />
        </div>
      </GoodsWrapper>
    );
  }
}
